export default [
  {
    path: 'https://vendas.vocepede.com.br/#/login',
    name: 'store-voce-pede',
    meta: {
      navbarTitle: 'Você pede',
      isAvaliableInMenu: true,
      menuData: {
        title: 'Você pede',
        id: 'vocePedeSidebar',
        section: 'Operação',
        icon: 'voce-pede',
      },
    },
  },
];
